import type { Options } from '@splidejs/splide';
import { responsiveBreakpointsPx } from '@/constants';

export const breadthOfContentSliderOptions: Options = Object.freeze({
    arrows: false,
    autoScroll: Object.freeze({ speed: 0.5 }),
    drag: 'free',
    focus: 'center',
    focusableNodes: '',
    gap: '16px',
    pagination: false,
    fixedWidth: '320px',
    perMove: 1,
    type: 'loop',
    mediaQuery: 'min',
    breakpoints: Object.freeze({
        [responsiveBreakpointsPx.md]: Object.freeze({
            fixedWidth: '420px',
        }),
    }),
    lazyLoad: true,
});
